<div class="content" fxLayout="column" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="12px"
    [@routeAnimation]="true">
    <div fxLayout="row" fxLayout.sm="column" fxLayoutAlign="start center" fxLayoutGap="16px">
        <div *ngIf="tableType !== 'paymentProcessor' && tableType !== 'paymentProcessor' && tableType !== 'form'">
            <button mat-raised-button color="primary" (click)="onCancel()">
                Cancel
            </button>
        </div>
        <div *ngIf="tableType !== 'paymentProcessor' && tableType !== 'paymentProcessor' && tableType !== 'form'">
            <button mat-raised-button color="primary" [disabled]="isPristine" (click)="onSave()">
                Save
            </button>
        </div>
        <div *ngIf="tableType === 'form'">
            <button mat-raised-button color="primary" (click)="onAdd()">
                New
            </button>
        </div>
    </div>
    <div class="filter">
        <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
        </mat-form-field>
    </div>
    <div fxLayout="column" class="mat-elevation-z8 table-container">
        <mat-table class="mat-elevation-z8 table-container" #table [dataSource]="dataSource" matSort>

            <!-- <ng-container matColumnDef="select">
                <mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle($event) : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
                    </mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? formDataChecked(row) : null"
                        [checked]="selection.isSelected(row)">
                    </mat-checkbox>
                </mat-cell>
            </ng-container> -->

            <ng-container matColumnDef="formType">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Form Type
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{getFormName(row.formType)}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="taxExemptStatus">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Tax-Exempt Status
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{getTaxExemptStatus(row.subsection)}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="paymentProcessor">
                <mat-header-cell style="flex-grow: 3;" *matHeaderCellDef mat-sort-header> Payment Processor
                </mat-header-cell>
                <mat-cell style="flex-grow: 3;" *matCellDef="let row"> {{row.paymentProcessor}} </mat-cell>
            </ng-container>
            <ng-container matColumnDef="paymentOption">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Payment Option
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{row.paymentOption}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="paymentOptions">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Payment Options
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row">
                    {{stringify( tableType ==='form'? getPaymentOptions(row.paymentProcessor): row.paymentOptions)}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="status">
                <mat-header-cell style="flex-grow: 1;" *matHeaderCellDef mat-sort-header>Is Active?
                </mat-header-cell>
                <mat-cell style="flex-grow: 1; " *matCellDef="let row">
                    <button mat-icon-button matTooltip="Toggle Status" matTooltipShowDelay="200"
                        (click)="toggleActiveStatus(row)">
                        <!-- {{row.isActive === 1? 'Active' :'InActive'}}   -->
                        <mat-icon *ngIf="row.isActive ===1" color="primary">check_circle</mat-icon>
                        <mat-icon *ngIf="row.isActive !==1" color="warn">cancel</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="taxExemptDescr">
                <mat-header-cell style="flex-grow: 4;" *matHeaderCellDef mat-sort-header> Description
                </mat-header-cell>
                <mat-cell style="flex-grow: 4;" *matCellDef="let row"> {{row.subsectionDescr}} </mat-cell>
            </ng-container>


            <ng-container matColumnDef="startDate">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Start Date
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{row.startDate | date: 'MM-dd-yyyy'}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="endDate">
                <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> End Date
                </mat-header-cell>
                <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{row.endDate | date: 'MM-dd-yyyy'}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="delete">
                <mat-header-cell style="flex-grow: 1; justify-content:center;" *matHeaderCellDef></mat-header-cell>
                <mat-cell style="flex-grow: 1; justify-content:center;" *matCellDef="let row" style="text-align:right;"
                    (click)="onDelete()">
                    <button mat-icon-button matTooltip="Delete Row" matTooltipShowDelay="200">
                        <mat-icon color="warn">delete</mat-icon>
                    </button>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectRow(row)"></mat-row>
        </mat-table>
    </div>
    <div fxLayout="column">
        <mat-paginator [pageSizeOptions]="[5, 10, 25, 100, 125, 150, 175, 200]"></mat-paginator>
    </div>
</div>